import React from 'react';
import { Link } from 'react-router-dom';
import './../styles/landing.css';

const NotFound = () => {
  return (
    <div className="not-found">
      <h1>404</h1>
      <p>The page you are looking for doesn't exist or has been moved.</p>
      <Link to="/" className="btn-primary" style={{ padding: '12px 28px', borderRadius: '6px', background: 'var(--accent)', color: 'white', fontWeight: 600 }}>
        Back to Home
      </Link>
    </div>
  );
};

export default NotFound;
